import {Module} from 'vuex';
import {state} from './state';
import {actions} from './actions'
import {mutations} from './mutations';
import {ParteState} from './types';
import {RootState} from '@/store/types';
const namespaced: boolean=true;
export const parteModule:Module<ParteState,RootState>={
    namespaced,
    state,
    mutations,
    actions
}